module.exports = __webpack_public_path__ + "img/rs_blackP-patch3.65940c5.png";